module.exports = __webpack_public_path__ + "static/2-57ef2cc9a7a0c6248b4983c2fc260626.jpg";